export default __webpack_public_path__ + "static/media/6.a9e3ef22.jpeg";